import React from 'react'

const Index = () => {
  return (
    <div><h2 style={{marginTop: "20px", color: "#fff"}}>No hay resultados</h2></div>
  )
}

export default Index;